import script from "./ArticleGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleGenerator.vue?vue&type=script&setup=true&lang=js"

import "./ArticleGenerator.vue?vue&type=style&index=0&id=bc0fa822&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc0fa822"]])

export default __exports__